export default "__VITE_ASSET__ufdjDYfV__"